// src/sections/ProductSection.js

import React from 'react';
import './ProductSection.css'; // Import CSS for styling
import pikeone from '../assets/pike1.jpg'; // Placeholder image for Product 1
import pikeauv from '../assets/pikeauv.jpg'; // Placeholder image for Product 2

const ProductSection = () => {
  return (
    <div className="product-section">
      <h1 className="section-title">Our Products</h1>

      <div className="product-container">
        {/* Product 1 */}
        <div className="product">
          <div className="product-info">
            <h2>PIKE 1</h2>
            <p>ROV for large area water inspections</p>
            <ul>
              <li>300m depth rating</li>
              <li>8h work time</li>
              <li>2 cameras (front and downwards)</li>
            </ul>
            <p className="navigation-title">Navigation:</p> {/* Updated here */}
            <ul>
              <li>DVL</li>
              <li>360° sonar</li>
            </ul>
          </div>
          <div className="product-image">
            <img src={pikeone} alt="Product 1" />
          </div>
        </div>

        {/* Product 2 - Image first, then info */}
        <div className="product">
          <div className="product-image">
            <img src={pikeauv} alt="Product 2" />
          </div>
          <div className="product-info">
            <h2>PIKE AUV</h2>
            <p>AUV for dual-use operations</p>
            <ul>
              <li>500m depth rating</li>
              <li>150km distance</li>
              <li>20kg payload</li>
              <li>7 days work time</li>
            </ul>
            <p className="navigation-title">Navigation:</p> {/* Updated here */}
            <ul>
              <li>DVL</li>
              <li>360° sonar</li>
              <li>INS</li>
              <li>GNSS</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ProductSection;
